export default __webpack_public_path__ + "static/26-0c3eba9cfe002545ddd9c3953a37ece5.jpg";